/** @typedef {() => void} AccessFiltersReloadHandler */

const EVENT_NAME = "exiqtive-access-filters-changed";

/**
 * Subscribe to Access switch / accessPermission refresh (ER-10192 / ER-10194).
 * Callers should reload persisted filters from localStorage for the new Access id.
 *
 * @param {AccessFiltersReloadHandler} handler
 * @returns {() => void} unsubscribe
 */
export function bindExiqtiveAccessFiltersChanged(handler) {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const listener = () => {
    handler();
  };

  window.addEventListener(EVENT_NAME, listener);
  return () => {
    window.removeEventListener(EVENT_NAME, listener);
  };
}

export { EVENT_NAME as EXIQTIVE_ACCESS_FILTERS_CHANGED_EVENT };
